
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 129 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59.71 32.172h-5.932l3.708-22.49h5.933l-3.708 22.49zM48.789 9.682l-5.656 15.47-.67-3.332.001.001-1.996-10.114s-.241-2.025-2.814-2.025h-9.35l-.11.381s2.86.587 6.206 2.57l5.154 19.54h6.181l9.438-22.49h-6.384zm46.661 22.49h5.447l-4.75-22.49h-4.768c-2.202 0-2.739 1.676-2.739 1.676l-8.847 20.814h6.184l1.237-3.34h7.541l.695 3.34zm-6.528-7.955l3.117-8.416 1.754 8.416h-4.87zm-8.665-9.126l.846-4.83s-2.612-.98-5.335-.98c-2.944 0-9.935 1.27-9.935 7.445 0 5.81 8.205 5.882 8.205 8.934 0 3.052-7.36 2.505-9.789.58l-.882 5.05s2.649 1.27 6.696 1.27c4.049 0 10.156-2.069 10.156-7.7 0-5.847-8.28-6.391-8.28-8.934.001-2.543 5.779-2.216 8.318-.835z","fill":"#545C69"}}),_c('path',{attrs:{"d":"M42.464 21.821l-1.996-10.114s-.242-2.025-2.815-2.025h-9.35l-.11.38s4.494.92 8.805 4.364c4.122 3.292 5.466 7.395 5.466 7.395z","fill":"#545C69"}})])
          )
        }
      }
    